'use client';

import React, { createContext, useContext } from 'react';

interface FirstSectionContextType {
  firstSectionId: string | null;
}

const FirstSectionContext = createContext<FirstSectionContextType>({
  firstSectionId: null
});

export function FirstSectionProvider({ 
  children, 
  firstSectionId 
}: { 
  children: React.ReactNode; 
  firstSectionId: string | null;
}) {
  return (
    <FirstSectionContext.Provider value={{ firstSectionId }}>
      {children}
    </FirstSectionContext.Provider>
  );
}

export function useFirstSection() {
  return useContext(FirstSectionContext);
}


















